import { BaseControl } from "../base-control";

class CheckboxControlCtrl extends BaseControl {
  checked = false;
  constructor(BaseControlService, $scope) { 
    'ngInject';
    super(BaseControlService, $scope);
  }

  modelChanged(newVal, oldVal) {
    super.modelChanged(newVal, oldVal);
    this.checked = newVal;
  }

  flipBoolModel() {
    this.enabled && this.stdModel(!this.stdModel());
  }

  checkboxKeyDown(keyEvent) {
    if ([13, 32].includes(keyEvent.which)) { // enter, spacebar
      keyEvent.preventDefault();
      this.flipBoolModel();
    }
  }

}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/checkbox-control/checkbox-control.component.html",
  controller: CheckboxControlCtrl
};